"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatEquation = void 0;
class StatEquation {
    constructor(name, equation) {
        this.name = name;
        this.equation = equation;
    }
    calculate(variables, parameters) {
        // TODO: Make sure it can be calculated
        return this.equation(variables, parameters);
    }
    getMissingTerms(variables = {}, parameters = {}) {
        const missingVariables = new Set();
        const missingParameters = new Set();
        // Find all variables necessary to calculate this equation
        const varProxy = new Proxy(variables, {
            get(target, prop, receiver) {
                if (variables[prop] === undefined) {
                    missingVariables.add(prop);
                    return Math.random() + 1; // Just to make sure we can process the equation without errors
                }
                return variables[prop];
            }
        });
        const paramProxy = new Proxy(parameters, {
            get(target, prop, receiver) {
                if (parameters[prop] === undefined) {
                    missingParameters.add(prop);
                    return Math.random() + 1; // Just to make sure we can process the equation without errors
                }
                return parameters[prop];
            }
        });
        this.equation(varProxy, paramProxy);
        return { missingVariables: missingVariables, missingParameters: missingParameters };
    }
    isCalculable(variables, parameters = {}) {
        const missingTerms = this.getMissingTerms(variables, parameters);
        return missingTerms.missingVariables.size === 0 && missingTerms.missingParameters.size === 0;
    }
}
exports.StatEquation = StatEquation;
